export var CarouselActionType;
(function (CarouselActionType) {
    CarouselActionType["TOGGLE_PLAY"] = "togglePlay";
    CarouselActionType["TOGGLE_MUTE"] = "toggleMute";
})(CarouselActionType || (CarouselActionType = {}));
export const videoCarouselReducer = (state, action) => {
    switch (action.type) {
        case CarouselActionType.TOGGLE_PLAY:
            return {
                ...state,
                carouselPlay: !state.carouselPlay,
            };
        case CarouselActionType.TOGGLE_MUTE:
            return {
                ...state,
                isMuted: !state.isMuted,
            };
        default:
            throw new Error(`Unknown action: ${action.type}`);
    }
};
